
import { Component, Vue } from "vue-property-decorator";
@Component
export default class CourseTimetable extends Vue {
  link: any;
  created(): void {
    this.link = this.$route.query.value;
  }
}
